const userSignUpDay = document.querySelector('.js-user-sign-up-select-day');
const userSignUpMonth = document.querySelector('.js-user-sign-up-select-month');
const userSignUpYear = document.querySelector('.js-user-sign-up-select-year');
const userSignUpBirthday = document.querySelector('.js-user-sign-up-birthday');

if (userSignUpDay && userSignUpMonth && userSignUpYear && userSignUpBirthday) {
  // When any of the select elements change, update the hidden input value with the new date
  userSignUpDay.addEventListener('change', updateUserBirthday);
  userSignUpMonth.addEventListener('change', updateUserBirthday);
  userSignUpYear.addEventListener('change', updateUserBirthday);

  function updateUserBirthday() {
    userSignUpBirthday.value = `${userSignUpDay.value}-${userSignUpMonth.value}-${userSignUpYear.value}`;
  }
}